import { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Form.scss";

const Form = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [submitError, setSubmitError] = useState("");

  const validate = () => {
    const newErrors = {};

    // Name
    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    } else if (form.name.length > 100) {
      newErrors.name = "Name is too long";
    }

    // Email
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailPattern.test(form.email)) {
      newErrors.email = "Please enter a valid email";
    }

    // Phone
    const phonePattern = /^[+]?[0-9\s-]{8,20}$/;

    if (form.phone.trim() && !phonePattern.test(form.phone)) {
      newErrors.phone = "Please enter a valid phone number";
    }

    // Message
    if (!form.message.trim()) {
      newErrors.message = "Message is required";
    } else if (form.message.length > 2000) {
      newErrors.message = "Message is too long";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setSuccess("");
    setSubmitError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    setSuccess("");
    setSubmitError("");

    try {
      await emailjs.send(
        "service_qk1s2yo",
        "template_4h9z4um",
        {
          from_name: form.name,
          from_email: form.email,
          phone: form.phone || "-",
          message: form.message,
        },
        "vHFzVyUv8fbiCt_0X"
      );

      setSuccess(
        "Thank you! Your message has been sent successfully."
      );

      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setErrors({});
    } catch (error) {
      console.error(error);

      setSubmitError(
        "Failed to send your message. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="contact-page">
      <section className="contact-section">
        <div className="form-card">
          <p className="subtitle">
            Have a project or question? We'd love to hear from you.
          </p>

          <form
            className="contact-form"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="form-group">
              <label>
                Name <span className="important">*</span>
              </label>

              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                maxLength={100}
                placeholder="John Doe"
              />

              {errors.name && (
                <span className="error">{errors.name}</span>
              )}
            </div>

            <div className="form-group">
              <label>
                Email <span className="important">*</span>
              </label>

              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="john@example.com"
              />

              {errors.email && (
                <span className="error">{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label>Phone</label>

              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+62 812 3456 7890"
              />

              {errors.phone && (
                <span className="error">{errors.phone}</span>
              )}
            </div>

            <div className="form-group">
              <label>
                Message <span className="important">*</span>
              </label>

              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                maxLength={2000}
                placeholder="Tell us about your project..."
              />

              <small className="char-counter">
                {form.message.length}/2000
              </small>

              {errors.message && (
                <span className="error">{errors.message}</span>
              )}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>

            {success && (
              <div className="success-message">
                {success}
              </div>
            )}

            {submitError && (
              <div className="submit-error">
                {submitError}
              </div>
            )}
          </form>
        </div>
      </section>
    </main>
  );
};

export default Form;